import {
    BASE_URL
} from './Authservice';

export const SERVICE = {

    FEATURE: `${BASE_URL}/api`,
    //user
    USER: `${BASE_URL}/api/users`,
    USER_CREATE: `${BASE_URL}/api/user/new`,
    USER_SINGLE: `${BASE_URL}/api/auth`,
    USER_SINGLEPW: `${BASE_URL}/api/userpw`,
    USER_TERMSTRUE: `${BASE_URL}/api/userstermstrue`,
    USER_TERMSFALSE: `${BASE_URL}/api/userstermsfalse`,
    USER_LASTINDEX: `${BASE_URL}/api/userlastindex`,
    USER_TERMSFALSE_LOCATION: `${BASE_URL}/api/userslocation`,
    USER_DELETE_ROLE_CHECK: `${BASE_URL}/api/checkrole`,
    USER_DELETE_DEPARTMENT_CHECK: `${BASE_URL}/api/checkdepartment`,
    USER_DELETE_LOCATION_CHECK: `${BASE_URL}/api/checklocation`,
    //role
    ROLE: `${BASE_URL}/api/roles`,
    ROLE_CREATE: `${BASE_URL}/api/role/new`,
    ROLE_SINGLE: `${BASE_URL}/api/role`,
    ROLE_LASTINDEX: `${BASE_URL}/api/rolelastindex`,
    ROLE_EDIT: `${BASE_URL}/api/editrole`,

    //role 
    ROLENEW: `${BASE_URL}/api/rolenews`,
    ROLENEW_CREATE: `${BASE_URL}/api/rolenew/new`,
    ROLENEW_SINGLE: `${BASE_URL}/api/rolenew`,
    ROLENEW_EDIT: `${BASE_URL}/api/editrolenew`,

    //departments
    DEPARTMENT: `${BASE_URL}/api/departments`,
    DEPARTMENT_CREATE: `${BASE_URL}/api/department/new`,
    DEPARTMENT_SINGLE: `${BASE_URL}/api/department`,
    DEPARTMENT_EDIT: `${BASE_URL}/api/editdepartment`,
    // Controls Grouping
    CONTROLSGROUPING: `${BASE_URL}/api/controlsgroupings`,
    CONTROLSGROUPING_CREATE: `${BASE_URL}/api/controlsgrouping/new`,
    CONTROLSGROUPING_SINGLE: `${BASE_URL}/api/controlsgrouping`,

    //supplier
    SUPPLIER: `${BASE_URL}/api/suppliers`,
    SUPPLIER_CREATE: `${BASE_URL}/api/supplier/new`,
    SUPPLIER_NAME_AUTOID: `${BASE_URL}/api/suppliersname`,
    EDIT_SUPPLIER: `${BASE_URL}/api/editsupplier`,
    SUPPLIER_SINGLE: `${BASE_URL}/api/supplier`,
    PURCHASE_DELETE_SUPPLIER_CHECK: `${BASE_URL}/api/checksupplier`,
    PURCHASE_DELETE_LOCATION_CHECK: `${BASE_URL}/api/checkpurlocation`,
    PURCHASE_DELETE_UNIT_CHECK: `${BASE_URL}/api/checkpurunit`,
    PURCHASE_DELETE_PRODUCT_CHECK: `${BASE_URL}/api/checkpurproduct`,
    PURCHASE_DELETE_TAXRATES_CHECK: `${BASE_URL}/api/checkpurtaxrates`,
    //customer
    CUSTOMER: `${BASE_URL}/api/customers`,
    CUSTOMER_CREATE: `${BASE_URL}/api/customer/new`,
    CUSTOMER_SINGLE: `${BASE_URL}/api/customer`,
    EDIT_CUSGRP: `${BASE_URL}/api/editcusgrp`,
    CUSTOMER_EDIT: `${BASE_URL}/api/customeredit`,
    //customer group
    CUSTOMER_GROUP: `${BASE_URL}/api/cgroups`,
    CUSTOMER_GROUP_CREATE: `${BASE_URL}/api/cgroup/new`,
    CUSTOMER_GROUP_SINGLE: `${BASE_URL}/api/cgroup`,
    CUSTOMER_GROUP_LASTINDEX: `${BASE_URL}/api/cgrouplastindex`,
    CUSTOMER_DELETE_CUSTOMERGRP_CHECK: `${BASE_URL}/api/checkcustomergroups`,
    //expense
    EXPENSE: `${BASE_URL}/api/expenses`,
    EXPENSE_CREATE: `${BASE_URL}/api/expense/new`,
    EXPENSE_SINGLE: `${BASE_URL}/api/expense`,
    EXPENSE_LASTINDEX: `${BASE_URL}/api/expenselastindex`,
    EXPENSEALL: `${BASE_URL}/api/totalexpenses`,
    EXPENSE_TODAY: `${BASE_URL}/api/todayexpenses`,
    EDIT_EXCATEGORY: `${BASE_URL}/api/editexcategory`,
    //expense due
    EXPENSE_DUES: `${BASE_URL}/api/expensedues`,
    EXPENSE_DUE_CREATE: `${BASE_URL}/api/expensesdue/new`,
    EXPENSE_DUE_SINGLE: `${BASE_URL}/api/expensedue`,
    //expense category
    EXPENSE_CATEGORY: `${BASE_URL}/api/expcategories`,
    EXPENSE_CATEGORY_CREATE: `${BASE_URL}/api/expcategory/new`,
    EXPENSE_CATEGORY_SINGLE: `${BASE_URL}/api/expcategory`,
    EXPENSE_CATEGORY_LASTINDEX: `${BASE_URL}/api/expcategorylastindex`,
    EXPENSE_DELETE_EXPCATEGORY_CHECK: ` ${BASE_URL}/api/checkexpcategory`,
    EXPENSE_DELETE_LOCATION_CHECK: `${BASE_URL}/api/checkexplocation`,
    EXPENSE_DELETE_TAXRATE_CHECK: `${BASE_URL}/api/checkexptaxrates`,
    EXPENSE_CATEGORY_OVERALL_DELETE: ` ${BASE_URL}/api/expcategoryoveralldelete`,
    EXPENSEPAGEGINATION: `${BASE_URL}/api/expensespagination`,


    //product
    // PRODUCT: `${BASE_URL}/api/products`,
    // PRODUCT_PURCHASE_DROPDOWN: `${BASE_URL}/api/productsfilterpurchasedropdown`,
    // PRODUCTSINGLESTOCK: `${BASE_URL}/api/productssinglestock`,
    // PRODUCTSINGLESTOCK_CONSOLIDATE: `${BASE_URL}/api/productsconsolidatestock`,
    // PRODUCT_CREATE: `${BASE_URL}/api/product/new`,
    // PRODUCT_SINGLE: `${BASE_URL}/api/product`,
    // PRODUCT_LASTINDEX: `${BASE_URL}/api/productslastindex`,
    // PRODUCT_LASTINDEXID: `${BASE_URL}/api/productsautoid`,
    // PRODUCT_NAME: `${BASE_URL}/api/productsname`,
    // PRODUCTSTOCK: `${BASE_URL}/api/productsstock`,
    // PRODUCT_DELETE_LOCATION_CHECK: `${BASE_URL}/api/checkprodlocation`,
    // PRODUCT_DELETE_SIZE_CHECK: `${BASE_URL}/api/checkprodsize`,
    // PRODUCT_DELETE_STYLE_CHECK: `${BASE_URL}/api/checkprodstyle`,
    // PRODUCT_DELETE_COLOR_CHECK: `${BASE_URL}/api/checkprodcolor`,
    // PRODUCT_DELETE_UNIT_CHECK: `${BASE_URL}/api/checkprodunit`,
    // PRODUCT_DELETE_RACK_CHECK: `${BASE_URL}/api/checkprodrack`,
    // PRODUCT_DELETE_BRAND_CHECK: `${BASE_URL}/api/checkprodbrand`,
    // PRODUCT_DELETE_CATEGORY_CHECK: `${BASE_URL}/api/checkprodcategory`,
    // PRODUCT_DELETE_TAXRATE_CHECK: `${BASE_URL}/api/checkprodtaxrates`,
    // PRODUCT_EDIT: `${BASE_URL}/api/editproductname`,

    //product
    PRODUCT: `${BASE_URL}/api/products`,
    PRODUCT_PAGINATION: `${BASE_URL}/api/productspagination`,
    PRODUCT_PURCHASE_DROPDOWN: `${BASE_URL}/api/productsfilterpurchasedropdown`,
    PRODUCTSINGLESTOCK: `${BASE_URL}/api/productssinglestock`,
    PRODUCTSINGLESTOCK_CONSOLIDATE: `${BASE_URL}/api/productsconsolidatestock`,
    PRODUCT_CREATE: `${BASE_URL}/api/product/new`,
    PRODUCT_SINGLE: `${BASE_URL}/api/product`,
    PRODUCT_LASTINDEX: `${BASE_URL}/api/productslastindex`,
    PRODUCT_LASTINDEXID: `${BASE_URL}/api/productsautoid`,
    PRODUCT_NAME: `${BASE_URL}/api/productsname`,
    PRODUCTSTOCK: `${BASE_URL}/api/productsstock`,
    PRODUCT_DELETE_LOCATION_CHECK: `${BASE_URL}/api/checkprodlocation`,
    PRODUCT_DELETE_SIZE_CHECK: `${BASE_URL}/api/checkprodsize`,
    PRODUCT_DELETE_STYLE_CHECK: `${BASE_URL}/api/checkprodstyle`,
    PRODUCT_DELETE_COLOR_CHECK: `${BASE_URL}/api/checkprodcolor`,
    PRODUCT_DELETE_UNIT_CHECK: `${BASE_URL}/api/checkprodunit`,
    PRODUCT_DELETE_RACK_CHECK: `${BASE_URL}/api/checkprodrack`,
    PRODUCT_DELETE_BRAND_CHECK: `${BASE_URL}/api/checkprodbrand`,
    PRODUCT_DELETE_CATEGORY_CHECK: `${BASE_URL}/api/checkprodcategory`,
    PRODUCT_DELETE_TAXRATE_CHECK: `${BASE_URL}/api/checkprodtaxrates`,
    PRODUCT_EDIT: `${BASE_URL}/api/editproductname`,
    LOCATION_WISE_PRODUCT: `${BASE_URL}/api/productlocation`,


    // section Group
    SECTION_GROUP: `${BASE_URL}/api/sectiongoups`,
    SECTION_GROUP_CREATE: `${BASE_URL}/api/sectiongroup/new`,
    SECTION_GROUP_SINGLE: `${BASE_URL}/api/sectiongroup`,
    SECTION_GROUP_DELETE_CATEGORY_CHECK: `${BASE_URL}/api/checksectiongoupscategory`,
    SECTION_GROUP_EDIT: `${BASE_URL}/api/editsectionname`,
    //unit
    UNIT: `${BASE_URL}/api/units`,
    UNIT_CREATE: `${BASE_URL}/api/unit/new`,
    UNIT_SINGLE: `${BASE_URL}/api/unit`,
    UNIT_GROUP_DELETE_UNIT_CHECK: `${BASE_URL}/api/checkgroupingsunit`,

    // unit Group
    UNIT_GROUPS: `${BASE_URL}/api/unitgroupings`,
    UNIT_GROUP_CREATE: `${BASE_URL}/api/unitgrouping/new`,
    UNIT_GROUP_SINGLE: `${BASE_URL}/api/unitgrouping`,
    UNIT_EDIT: `${BASE_URL}/api/unitedit`,

    //STYLE...  
    STYLE: `${BASE_URL}/api/styles`,
    STYLE_EDIT: `${BASE_URL}/api/styleedit`,
    STYLE_CREATE: `${BASE_URL}/api/style/new`,
    STYLE_SINGLE: `${BASE_URL}/api/style`,
    //Brand....

    BRAND: `${BASE_URL}/api/brands`,
    BRAND_PAGINATION: `${BASE_URL}/api/brandspagination`,
    ALLSUBBRAND: `${BASE_URL}/api/subbrands`,
    BRAND_CREATE: `${BASE_URL}/api/brand/new`,
    BRAND_SINGLE: `${BASE_URL}/api/brand`,
    BRAND_EDIT: `${BASE_URL}/api/editbrandname`,
    BRANDNAMESUBBRAND: `${BASE_URL}/api/brandnamesubbrand`,
    CATEGORYNAMESUBCATEGORY: `${BASE_URL}/api/categorynamesubcategory`,

    // Group Start
    GROUPS: `${BASE_URL}/api/groups`,
    GROUPS_PAGINATION: `${BASE_URL}/api/groupspagination`,
    GROUP_CREATE: `${BASE_URL}/api/group/new`,
    GROUP_SINGLE: `${BASE_URL}/api/group`,
    GROUP_DELETE_BRAND_CHECK: `${BASE_URL}/api/checkgroupsbrand`,
    GROUP_DELETE_CATEGORY_CHECK: `${BASE_URL}/api/checkgroupscategory`,

    // Group End
    //categories
    CATEGORIES: `${BASE_URL}/api/categories`,
    CATEGORIES_PAGINATION: `${BASE_URL}/api/categoriespagination`,
    CATEGORIES_CREATE: `${BASE_URL}/api/category/new`,
    CATEGORIES_SINGLE: `${BASE_URL}/api/category`,
    CATEGORIES_SUBCATEGORY: `${BASE_URL}/api/categorysubcategories`,
    CATEGORIES_BRAND: `${BASE_URL}/api/categorybrands`,
    EDIT_CATEGORY: `${BASE_URL}/api/editcategory`,

    //color
    COLOR: `${BASE_URL}/api/colors`,
    COLOR_CREATE: `${BASE_URL}/api/color/new`,
    COLOR_SINGLE: `${BASE_URL}/api/color`,
    COLOR_EDIT: `${BASE_URL}/api/coloredit`,
    //size
    SIZE: `${BASE_URL}/api/sizes`,
    SIZE_CREATE: `${BASE_URL}/api/size/new`,
    SIZE_SINGLE: `${BASE_URL}/api/size`,
    EDIT_SIZE: `${BASE_URL}/api/editsize`,
    //purchase
    PURCHASE: `${BASE_URL}/api/purchases`,
    PURCHASELIST: `${BASE_URL}/api/purchaseslist`,
    PURCHASEPRODUCTS: `${BASE_URL}/api/purchasesstock`,
    PURCHASEPRODUCTS_CONSOLIDATE: `${BASE_URL}/api/purchasesconsolidatestock`,
    PURCHASE_CREATE: `${BASE_URL}/api/purchase/new`,
    PURCHASE_SINGLE: `${BASE_URL}/api/purchase`,
    PURCHASE_LASTINDEX: `${BASE_URL}/api/purchasesautoid`,
    PURCHASE_TODAY: `${BASE_URL}/api/todaypurchases`,
    DASHPURCHASES: `${BASE_URL}/api/totalpurchases`,
    WEEKLYPURCHASE: `${BASE_URL}/api/weeklypurchases`,
    //purchase return
    PURCHASE_RETURN: `${BASE_URL}/api/purchasereturns`,
    PURCHASE_RETURN_CREATE: `${BASE_URL}/api/purchasereturn/new`,
    PURCHASE_RETURN_SINGLE: `${BASE_URL}/api/purchasereturn`,
    PURCHASE_RETURN_LASTINDEX: `${BASE_URL}/api/purchasereturnlastindex`,
    PURCHASE_RETURNDASH: `${BASE_URL}/api/totalpurchasertn`,
    PURCHASERETURN_TODAY: `${BASE_URL}/api/todaypurchasereturns`,
    PURCHASERTN_DELETE_SUPPLIER_CHECK: `${BASE_URL}/api/checkreturnsupplier`,
    PURCHASERTN_DELETE_LOCATION_CHECK: `${BASE_URL}/api/checkreturnlocation`,
    PURCHASERTN_DELETE_UNIT_CHECK: `${BASE_URL}/api/checkpurrtnunit`,
    PURCHASERTN_DELETE_PRODUCT_CHECK: `${BASE_URL}/api/checkpurrtnproduct`,
    PURCHASERTN_DELETE_TAXRATES_CHECK: `${BASE_URL}/api/checkpurrtntaxrates`,

    //pos
    POS: `${BASE_URL}/api/pos`,
    POS_CREATE: `${BASE_URL}/api/pos/new`,
    POS_SINGLE: `${BASE_URL}/api/pos`,
    POS_LASTINDEX: `${BASE_URL}/api/poslastindex`,
    POS_TODAY: `${BASE_URL}/api/todaysales`,
    ALLPOS: `${BASE_URL}/api/allpos`,
    ALLPOSSALES: `${BASE_URL}/api/allpossales`,
    ALLRECENTSALES: `${BASE_URL}/api/recentsales`,
    WEEKLYSALEPOS: `${BASE_URL}/api/weeklysales`,
    SELLINGPURCHASEPRODUCTS: `${BASE_URL}/api/sellingpurchaseproducts`,
    SELLINGMANUALSTOCKPRODUCTS: `${BASE_URL}/api/sellingmanualstockproducts`,
    CURRENTMONTHTOPFIVESALESPRODUCTS: `${BASE_URL}/api/topfivesales`,
    CURRENTMONTHTOPFIVEPRODUCTS: `${BASE_URL}/api/currentmonthtopfivesales`,
    TOPFIVE: `${BASE_URL}/api/currentmontcustomers`,
    TOPFIVE_TABLE: `${BASE_URL}/api/topfiveprodtable`,
    POS_DELETE_CUSTOMER_CHECK: `${BASE_URL}/api/checkposcustomer`,
    POS_DELETE_LOCATION_CHECK: `${BASE_URL}/api/checkposlocation`,
    POS_DELETE_PRODUCT_CHECK: `${BASE_URL}/api/checkposproduct`,
    POS_DELETE_TAXRATES_CHECK: `${BASE_URL}/api/checkpostaxrates`,
    DRAFT_GOODS: `${BASE_URL}/api/draftgoods`,
    QUOTATION_GOODS: `${BASE_URL}/api/quoationgoods`,
    POS_GOODS: `${BASE_URL}/api/posgoods`,
    POS_SALESREPORT: `${BASE_URL}/api/possalesfilter`,
    POS_SALESPERSONREPORT: `${BASE_URL}/api/possalespersonfilter`,
    POS_DAILYBALANCEREPORT: `${BASE_URL}/api/posdailybalancefilter`,
    POS_MONTHLYBALANCEREPORT: `${BASE_URL}/api/posmonthlybalancefilter`,
    POS_WARRANTYLISTFILTER: `${BASE_URL}/api/poswarrantylistfilter`,

    // categoryproducts 
    CATEGORIESPRODUCTS: `${BASE_URL}/api/categoryproducts`,
    CATEGORIESPRODUCTS_PAGINATION: `${BASE_URL}/api/categoryproductspagination`,
    CATEGORIESPRODUCTS_CREATE: `${BASE_URL}/api/categoryproduct/new`,
    CATEGORIESPRODUCTS_SINGLE: `${BASE_URL}/api/categoryproduct`,
    CATEGORIESPRODUCTS_SUBCATEGORY: `${BASE_URL}/api/categoryproductssubcategories`,

    //draft
    DRAFT: `${BASE_URL}/api/drafts`,
    DRAFT_CREATE: `${BASE_URL}/api/draft/new`,
    DRAFT_SINGLE: `${BASE_URL}/api/draft`,
    DRAFT_LASTINDEX: `${BASE_URL}/api/draftlastindex`,
    DRAFT_TODAY: `${BASE_URL}/api/todaydrafts`,
    ALLDRAFT: `${BASE_URL}/api/alldrafts`,
    DRAFT_DELETE_CUSTOMER_CHECK: `${BASE_URL}/api/checkdraftcustomer`,
    DRAFT_DELETE_LOCATION_CHECK: `${BASE_URL}/api/checkdraftlocation`,
    DRAFT_DELETE_PRODUCT_CHECK: `${BASE_URL}/api/checkdraftproduct`,
    DRAFT_DELETE_TAXRATES_CHECK: `${BASE_URL}/api/checkdrafttaxrates`,

    //quotation
    QUOTATION: `${BASE_URL}/api/quoations`,
    QUOTATION_CREATE: `${BASE_URL}/api/quoation/new`,
    QUOTATION_SINGLE: `${BASE_URL}/api/quoation`,
    QUOTATION_LASTINDEX: `${BASE_URL}/api/quoationlastindex`,
    QUOTATION_TODAY: `${BASE_URL}/api/todayquoations`,
    ALLQUOTATION: `${BASE_URL}/api/allquoations`,
    QUOTATION_DELETE_CUSTOMER_CHECK: `${BASE_URL}/api/checkquotationcustomer`,
    QUOTATION_DELETE_LOCATION_CHECK: `${BASE_URL}/api/checkquotationlocation`,
    QUOTATION_DELETE_PRODUCT_CHECK: `${BASE_URL}/api/checkquotationproduct`,
    QUOTATION_DELETE_TAXRATES_CHECK: `${BASE_URL}/api/checkquotationtaxrates`,

    //settings
    SETTINGS: `${BASE_URL}/api/busisetngs`,
    SETTING_CREATE: `${BASE_URL}/api/busisetng/new`,
    SETTING_SINGLE: `${BASE_URL}/api/busisetng`,

    //business location
    BUSINESS_LOCATION: `${BASE_URL}/api/businesslocations`,
    BUSINESS_LOCATION_CREATE: `${BASE_URL}/api/businesslocation/new`,
    BUSINESS_LOCATION_SINGLE: `${BASE_URL}/api/businesslocation`,
    BUSINESS_LOCATION_LASTINDEX: `${BASE_URL}/api/busilocationlastindex`,
    BUSINESS_LOCATION_OVERALL_DELETE: `${BASE_URL}/api/businesslocationoveralldelete`,

    //taxrate
    TAXRATE: `${BASE_URL}/api/taxrates`,
    TAXRATEFALSE: `${BASE_URL}/api/taxratesforgroupfalse`,
    TAXRATEHSN: `${BASE_URL}/api/taxrateshsn`,
    TAXRATEGROUPFALSE: `${BASE_URL}/api/taxratesgroupforgroupfalse`,
    TAXRATEGROUP: `${BASE_URL}/api/taxratesgroup`,
    TAXRATEGROUPHSN: `${BASE_URL}/api/taxratesforgrouphsnfalse`,
    TAXRATE_CREATE: `${BASE_URL}/api/taxrate/new`,
    TAXRATE_SINGLE: `${BASE_URL}/api/taxrate`,
    TAXRATE_EDIT: `${BASE_URL}/api/edittaxrates`,
    TAXRATE_OVERALL_DELETE: `${BASE_URL}/api/taxrateoveralldelete`,
    TAXRATEGRP_OVERALL_DELETE: `${BASE_URL}/api/taxrategrpoveralldelete`,
    TAXRATEHSN_OVERALL_DELETE: `${BASE_URL}/api/taxratehsnoveralldelete`,

    //alpharate
    ALPHARATE: `${BASE_URL}/api/alpharates`,
    ALPHARATEACTIVE: `${BASE_URL}/api/alpharatesactive`,
    ALPHARATE_CREATE: `${BASE_URL}/api/alpharate/new`,
    ALPHARATE_SINGLE: `${BASE_URL}/api/alpharate`,
    //payment integratin
    PAYMENTINTEGRATION: `${BASE_URL}/api/payments`,
    PAYMENTINTEGRATION_CREATE: `${BASE_URL}/api/payment/new`,
    PAYMENTINTEGRATION_SINGLE: `${BASE_URL}/api/payment`,
    //stock
    STOCK: `${BASE_URL}/api/stocks`,
    STOCKPRODUCTS: `${BASE_URL}/api/stocksproducts`,
    STOCKSALESTATUSS: `${BASE_URL}/api/stocksalestatuss`,
    OVERALLSTOCKPRODUCTS: `${BASE_URL}/api/overallstocksproducts`,
    STOCKPRODUCTS_CONSOLIDATE: `${BASE_URL}/api/stocksproductsconsolidate`,
    STOCKCATEGORIES: `${BASE_URL}/api/stockscategories`,
    STOCKPRODUCTCATEGORIES: `${BASE_URL}/api/stocksproductcategories`,
    STOCKADJUSTPRODUCTS: `${BASE_URL}/api/stocksadjustproducts`,
    STOCKADJUSTPRODUCTS_CONSOLIDATE: `${BASE_URL}/api/stocksadjustproductsconsolidate`,
    MANUALSTOCKENTRYPRODUCTS: `${BASE_URL}/api/manualstockentryproducts`,
    MANUALSTOCKENTRYPRODUCTS_CONSOLIDATE: `${BASE_URL}/api/manualstockentryproductsconslidate`,
    STOCK_SINGLE: `${BASE_URL}/api/stock`,
    STOCK_CREATE: `${BASE_URL}/api/stock/new`,
    STOCKSALESPRODUCTS: `${BASE_URL}/api/allstocksproducts`,
    STOCKADJUST_DELETE_SECTION_CHECK: `${BASE_URL}/api/checkstocksection`,
    STOCKADJUST_DELETE_ADJUSTTYPE_CHECK: `${BASE_URL}/api/checkstockadjusttype`,
    PURCHASECATEGORYPRODUCTS: `${BASE_URL}/api/stockpurchaseproducts`,
    PURCHASECATEGORYPRODUCTSCONSOLIDATED: `${BASE_URL}/api/stockpurchaseproductsconsolidated`,
    STOCK_SINGLE_PRODUCT_UPDATE_FROM_ADDTOPRINTQUEUE: `${BASE_URL}/api/updateLabelStatusFromQueue`,
    //RE-PRINT
    STOCK_SINGLE_PRODUCT_UPDATE: `${BASE_URL}/api/updateLabelStatus`,
    // all consolidated pages
    STOCK_FOR_ALL_CONSOLIDATED_PAGES: `${BASE_URL}/api/allstockconsolidated`,
    STOCK_FOR_NOT_PRINTED_CONSOLIDATED_PAGE: `${BASE_URL}/api/allstockconsolidatedfornotprinted`,

    //ManualstockEntry
    MANUALSTOCKENTRY: `${BASE_URL}/api/manualstockentrys`,
    MANUALSTOCKENTRY_PAGINATION: `${BASE_URL}/api/manualstockentryspagination`,
    MANUALSTOCKENTRY_CREATE: `${BASE_URL}/api/manualstockentry/new`,
    MANUALSTOCKENTRY_SINGLE: `${BASE_URL}/api/manualstockentry`,
    MANUALSTOCKENTRY_FILTER: `${BASE_URL}/API/manualstockentryfilter`,

    //Addtoprintqueue
    ADDTOPRINTQUEUE: `${BASE_URL}/api/addtoprintqueues`,
    ADDTOPRINTQUEUE_CREATE: `${BASE_URL}/api/addtoprintqueue/new`,
    ADDTOPRINTQUEUE_SINGLE: `${BASE_URL}/api/addtoprintqueue`,
    ADDTOPRINTQUEUE_FOR_STOCK_PAGINATION: `${BASE_URL}/api/addtoprintqueuesforstockpagination`,

    //discount
    DISCOUNT: `${BASE_URL}/api/discounts`,
    DISCOUNT_PAGINATION: `${BASE_URL}/api/discountspagination`,
    DISCOUNT_CREATE: `${BASE_URL}/api/discount/new`,
    DISCOUNT_SINGLE: `${BASE_URL}/api/discount`,
    DISCOUNT_DELETE_LOCATION_CHECK: `${BASE_URL}/api/checkstockadjusttype`,

    //stock transfer
    TRANSFERS: `${BASE_URL}/api/transfers`,
    TRANSFER_CREATE: `${BASE_URL}/api/transfer/new`,
    TRANSFER_SINGLE: `${BASE_URL}/api/transfer`,
    ALLTRANSFERS: `${BASE_URL}/api/alltransfers`,
    ALLADJUSTS: `${BASE_URL}/api/alladjusts`,

    // Adjustment Start
    ADJUSTMENTTYPE: `${BASE_URL}/api/adjustmenttypes`,
    ADJUSTMENTTYPE_CREATE: `${BASE_URL}/api/adjustmenttype/new`,
    ADJUSTMENTTYPE_SINGLE: `${BASE_URL}/api/adjustmenttype`,
    ADJUSTMENTTYPE_EDIT: `${BASE_URL}/api/editadjustmenttypes`,

    ADJUSTMENT: `${BASE_URL}/api/adjustments`,
    ADJUSTMENT_CREATE: `${BASE_URL}/api/adjustment/new`,
    ADJUSTMENT_SINGLE: `${BASE_URL}/api/adjustment`,
    ADJUSTMENTPRODUCTPURCHASE: `${BASE_URL}/api/purchasesstockadjustments`,
    PRODUCT_CSC_BSB_SIZE_COLOR_STYLE: `${BASE_URL}/api/productsbycsc_bsb_sizeandcolorandstyle`,
    STOCK_ADJUSTMENTS: `${BASE_URL}/api/stockadjustments`,
    STOCK_ADJUSTMENTS_PAGINATION: `${BASE_URL}/api/stockadjustmentspagination`,
    STOCK_ADJUSTMENT_CREATE: `${BASE_URL}/api/stockadjustment/new`,
    STOCK_ADJUSTMENT_SINGLE: `${BASE_URL}/api/stockadjustment`,
    SUB_CATEGORIES: `${BASE_URL}/api/subcategories`,
    SUB_BRANDS: `${BASE_URL}/api/allsubbrands`,
    SUB_BRANDS_ALLSUBARRAY: `${BASE_URL}/api/allsubbrandssubarray`,
    ADJUSTMENTPRODUCT_SOLD_STOCK: `${BASE_URL}/api/innerstockarray`,
    STOCK_DELETE_SIZE_CHECK: `${BASE_URL}/api/checkstocksize`,
    STOCK_DELETE_BRAND_CHECK: `${BASE_URL}/api/checkstockbrand`,
    STOCK_DELETE_CATEGORY_CHECK: `${BASE_URL}/api/checkstockcategory`,
    STOCK_DELETE_RACK_CHECK: `${BASE_URL}/api/checkstockrack`,
    PRODUCT_CATEGORY_STOCK: `${BASE_URL}/api/stockcategoryviceproducts`,
    STOCK_CONSOLIDATE: `${BASE_URL}/api/stockconsolidate`,

    //password
    PASSWORD: `${BASE_URL}/api/passwords`,
    PASSWORD_CREATE: `${BASE_URL}/api/password/new`,
    PASSWORD_SINGLE: `${BASE_URL}/api/password`,

    //  Folder
    FOLDER: `${BASE_URL}/api/folders`,
    FOLDER_CREATE: `${BASE_URL}/api/folder/new`,
    FOLDER_SINGLE: `${BASE_URL}/api/folder`,

    //assign password
    ASSIGNPASSWORDS: `${BASE_URL}/api/userassignments`,
    ASSIGNPASSWORD_CREATE: `${BASE_URL}/api/userassign/new`,
    ASSIGNPASSWORD_SINGLE: `${BASE_URL}/api/userassign`,

    //Rack...
    RACK: `${BASE_URL}/api/racks`,
    RACK_PAGINATION: `${BASE_URL}/api/rackspagination`,
    RACK_SUBRACK_SUBSUBRACK: `${BASE_URL}/api/rackssubrackssubsubracks`,
    RACK_CREATE: `${BASE_URL}/api/rack/new`,
    RACK_SINGLE: `${BASE_URL}/api/rack`,
    RACK_EDIT: `${BASE_URL}/api/editracks`,
    ASSIGNRACK_FILTER: `${BASE_URL}/api/assignrackfilter`,

    //labels
    LABELS: `${BASE_URL}/api/labels`,
    LABEL_CREATE: `${BASE_URL}/api/label/new`,
    LABEL_SINGLE: `${BASE_URL}/api/label`,


    USER_PAGINATION: `${BASE_URL}/api/userpagination`,
    ROLE_PAGINATION: `${BASE_URL}/api/rolepagination`,
    DEPARTMENT_PAGINATION: `${BASE_URL}/api/departmentspagination`,
    SUPPLLIER_PAGINATION: `${BASE_URL}/api/supplierspagination`,
    CUSTOMER_PAGINATION: `${BASE_URL}/api/customerpagination`,
    CUSTOMER_GROUP_PAGINATION: `${BASE_URL}/api/customergrouppagination`,
    PURCHASE_PAGINATION: `${BASE_URL}/api/purchasespagination`,
    PURCHASE_RETURN_PAGINATION: `${BASE_URL}/api/purchasereturnpagination`,
    POS_PAGINATION: `${BASE_URL}/api/pospagination`,
    DRAFT_PAGINATION: `${BASE_URL}/api/draftpagination`,
    QUOTATION_PAGINATION: `${BASE_URL}/api/quoationspagination`,

    // Type
    TYPE: `${BASE_URL}/api/types`,
    TYPE_CREATE: `${BASE_URL}/api/type/new`,
    TYPE_SINGLE: `${BASE_URL}/api/type`,
    // Codecoating
    CODECOATING: `${BASE_URL}/api/codecoatings`,
    CODECOATING_CREATE: `${BASE_URL}/api/codecoating/new`,
    CODECOATING_SINGLE: `${BASE_URL}/api/codecoating`,
    CODECOATING_PRODUCT_PURCHASE_DROPDOWN: `${BASE_URL}/api/productscoatingfilterpurchasedrop`,
    PRODUCTCOATINGSINGLESTOCK_CONSOLIDATE: `${BASE_URL}/api/productcoatingsconsolidatestock`,

    //Warranty Details
    WARRANTY_DETAILS: `${BASE_URL}/api/warrantydetails`,
    WARRANTY_DETAILS_CREATE: `${BASE_URL}/api/warrantydetail/new`,
    WARRANTY_DETAILS_SINGLE: `${BASE_URL}/api/warrantydetail`,

    //Shift
    SHIFT: `${BASE_URL}/api/shifts`,
    SHIFT_CREATE: `${BASE_URL}/api/shift/new`,
    SHIFT_SINGLE: `${BASE_URL}/api/shift`,

    // Manual Purchase 
    MANUALPURCHASE: `${BASE_URL}/api/manualpurchase`,
    MANUALPURCHASE_CREATE: `${BASE_URL}/api/manualpurchase/new`,
    MANUALPURCHASE_SINGLE: `${BASE_URL}/api/manualpurchase`,
    MANUALPURCHASEMANY_CREATE: `${BASE_URL}/api/manualpurchasebulk/new`,
    MANUALPURCHASEPAGINATION: `${BASE_URL}/api/manualpurchasepagination`,
    MANUALPURCHASE_LASTINDEX: `${BASE_URL}/api/manualpurchasesautoid`,

    CODECOATING_PRODUCT_MANUALPURCHASE_DROPDOWN: `${BASE_URL}/api/productscoatingfilterManualpurchasedrop`,
};